export default __webpack_public_path__ + "static/media/Belt of the Harbinger.97c11785.jpg";